import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm an <b className="purple">AI Native Software Engineer</b> and
              Full-Stack Developer who loves turning ideas into real products
              with code and AI. 🤖
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> C++, Javascript and Python</b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
              also in areas related to{" "}
                <b className="purple">
                  AI/ML.
                </b>
              </i>
              <br />
              <br />
              I currently work as an <b className="purple">AI Native Software
              Engineer Intern at Chegg</b> and am diving deeper into
              <i>
                <b className="purple">
                  {" "}
                  LLMs, RAG, AI Agents and AI-assisted development
                </b>
              </i>
              .
              <br />
              <br />
              Whenever possible, I apply my passion for building products with
              <b className="purple"> Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/imshashwatsingh"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/imshash140403"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/shashwat-singh14/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/imshashwatsingh14/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        {/* <Row className="home-stats-row">
          <Col xs={6} md={3} className="home-stat">
            <h3 className="home-stat-value">57+</h3>
            <p className="home-stat-label">Repositories</p>
          </Col>
          <Col xs={6} md={3} className="home-stat">
            <h3 className="home-stat-value">8.7</h3>
            <p className="home-stat-label">MCA CGPA '26</p>
          </Col>
          <Col xs={6} md={3} className="home-stat">
            <h3 className="home-stat-value">MERN</h3>
            <p className="home-stat-label">Full-Stack</p>
          </Col>
          <Col xs={6} md={3} className="home-stat">
            <h3 className="home-stat-value">AI</h3>
            <p className="home-stat-label">Native Engineer</p>
          </Col>
        </Row> */}
      </Container>
    </Container>
  );
}
export default Home2;
